import * as React from 'react';
import { Alert, Typography } from '@mui/material';
import { useGetIdentity } from 'react-admin';

/**
 * Explains post-expiry grace: full access continues until `licenseAccessEndsOnUtc` (UTC calendar day).
 */
export function LicenseGraceBanner() {
    const { identity } = useGetIdentity();
    const inGrace = (identity as { licenseInGracePeriod?: boolean } | undefined)?.licenseInGracePeriod === true;
    const locked = (identity as { companyLicenseLocked?: boolean } | undefined)?.companyLicenseLocked === true;
    const endsOn = (identity as { licenseAccessEndsOnUtc?: string } | undefined)?.licenseAccessEndsOnUtc;
    const daysLeft = (identity as { licenseDaysRemaining?: number } | undefined)?.licenseDaysRemaining;

    if (!inGrace || locked || !endsOn) return null;

    return (
        <Alert severity="warning" sx={{ borderRadius: 0, py: 0.5 }}>
            <Typography variant="body2" component="span">
                Your license expiry date has passed, but your company is in a <strong>grace period</strong>. Full
                access continues through <strong>{endsOn}</strong> (UTC){daysLeft != null ? ` (${daysLeft} day(s) left)` : ''}.
                Set <strong>Grace period days</strong> to <strong>0</strong> in the admin portal if access should stop
                the day after the expiry date.
            </Typography>
        </Alert>
    );
}
